import { render, staticRenderFns } from "./DigitalDocShortList.vue?vue&type=template&id=2461d308&scoped=true"
import script from "./DigitalDocShortList.vue?vue&type=script&lang=js"
export * from "./DigitalDocShortList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461d308",
  null
  
)

export default component.exports